var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "form-group", attrs: { sm: "6" } },
        [
          _c("form-write-group-label-input", {
            attrs: {
              isMandatory: "",
              disabled: _vm.readonly,
              inputLabel: _vm.$t("common.routing.config_name"),
              placeholderValue: _vm.$t("common.routing.config_name"),
            },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "form-group", attrs: { sm: "6" } },
        [
          _c("form-write-group-label-input", {
            attrs: {
              isMandatory: "",
              disabled: _vm.readonly,
              inputLabel: _vm.$t("common.routing.path"),
              placeholderValue: _vm.$t("common.routing.path"),
            },
            model: {
              value: _vm.path,
              callback: function ($$v) {
                _vm.path = $$v
              },
              expression: "path",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }